<script lang='ts'>
    import MpaSummaryText from "../../Common/MpaSummaryText.svelte";
    import { getFocus } from "@/Common/constants";
    import { specificityToRating } from "@/Util/utils";
    import MpaSummaryPcntChart from "../../Common/MpaSummaryPcntChart.svelte";
    import type { SummaryData } from "@/Activities/ActivityAnalytics";
    import type { MyFitnessStores } from "@/MyFitness/stores";
    import { getContext } from "svelte";

    let { userParams } = getContext<MyFitnessStores>("myFitness")

    export let summary: Partial<SummaryData>
</script>

<div class="flex flex-col">
    <div class="flex flex-row gap-x-2">
        <div class="flex-1">
            <MpaSummaryPcntChart text={`Power (W)`} value={summary.power?.avg} total={summary.power?.max} colorPri="#ff8466" colorSec="#ffd6cc" />
        </div>
        <div class="flex-1">
            <MpaSummaryPcntChart text={`Speed (${$userParams.activityUnits.spd})`} value={summary.speed?.avg} total={summary.speed?.max} colorPri="#c9ec66" colorSec="#edf9cc" />
        </div>
        <div class="flex-1">
            <MpaSummaryPcntChart text={`Cadence (rpm)`} value={summary.cadence?.avg} total={summary.cadence?.max} colorPri="#68d2ce" colorSec="#ccf0ef" />
        </div>
    </div>
    <table class="border-collapse table-fixed">
        <tr>
            <td>
                <MpaSummaryText text={`Distance (${$userParams.activityUnits.dist})`} value={summary.distance?.toFixed(2)} />
            </td>
            <td>
                <MpaSummaryText text={`Elevation Gain (${$userParams.activityUnits.alt})`} value={summary.altGain?.toFixed(0)} />
            </td>
            <td>
                <MpaSummaryText text={`Work (kJ)`} value={summary.power ? (summary.power.total / 1000).toFixed(0) : null} />
            </td>
            <td>
                <MpaSummaryText text={`Equiv. Power (W)`} value={summary.xep?.toFixed(0)} />
            </td>
        </tr>
        <tr>
            <td>
                <MpaSummaryText text={`Strain Score (XSS)`} value={summary.strain?.toFixed(0)} />
            </td>
            <td>
                <MpaSummaryText text={`Calories (kCal)`} value={summary.power ? ((summary.power.total * 1.1) / 1000).toFixed(0) : null} />
            </td>
            <td>
                <MpaSummaryText text={`Fat (grams)`} value={summary.fat?.toFixed(0)} />
            </td>
            <td>
                <MpaSummaryText text={`Carbs (grams)`} value={summary.carbs?.toFixed(0)} />
            </td>
        </tr>
        <tr>
            <td>
                <MpaSummaryText text={`Starting MPA (W)`} value={summary.startMpa?.toFixed(0)} />
            </td>
            <td>
                <MpaSummaryText text={`Ending MPA (W)`} value={summary.endMpa?.toFixed(0)} />
            </td>
            <td>
                <MpaSummaryText text={`Focus`} value={summary.focusDuration ? getFocus($userParams.athletes, summary.focusDuration) : null} />
            </td>
            <td>
                <MpaSummaryText text={`Specificity`} value={summary.specificity ? specificityToRating(summary.specificity) : null} />
            </td>
        </tr>
    </table>
</div>